'use strict';
angular
    .module('dnapp')
    .factory('DN.InternalSearchService', ['$resource', function ($resource) {
        return $resource('/umbraco/api/searchapi/:action', {}, {
            Search: { method: "GET", params: { action: "Search" } },
            TypeaheadSearch: { method: "GET", params: { action: "TypeaheadSearch" } }
        });
    }]);